module.exports = __webpack_public_path__ + "images/89773d7b2ba28ebac762f3016c8f9abe-logo_dark.png";